import styled from 'styled-components';

const AppCardFooter = styled.div`
  padding-bottom: 18px;
  padding-left: ${(props) => (props.center ? '0px' : '18px')};
  text-align: ${(props) => (props.center ? 'center' : 'initial')};
`;

AppCardFooter.displayName = 'AppCardFooter';

export { AppCardFooter };
